parcelRequire.extendImportMap({"kMNbZ":"loadCognitoIdentity.e3191a3b.js"});